import { createMiddleware, createStart } from '@tanstack/react-start';
import { APP_VERSION_HEADER, APP_VERSION_STORAGE_KEY } from '@/lib/app-version';

function syncVersionFromHeader(response: Response) {
	if (typeof window === 'undefined') {
		return;
	}

	const version = response.headers.get(APP_VERSION_HEADER);
	if (!version) {
		return;
	}

	const currentVersion = window.localStorage.getItem(APP_VERSION_STORAGE_KEY);
	if (!currentVersion) {
		window.localStorage.setItem(APP_VERSION_STORAGE_KEY, version);
		return;
	}

	if (currentVersion !== version) {
		window.localStorage.setItem(APP_VERSION_STORAGE_KEY, version);
	}
}

const appVersionAwareFetch = Object.assign((...args: Parameters<typeof fetch>) => {
	return fetch(...args).then((response) => {
		syncVersionFromHeader(response);
		return response;
	});
}, fetch);

const appVersionHeaderMiddleware = createMiddleware({ type: 'request' }).server(async (options) => {
	const result = await options.next();

	if (result?.response?.headers) {
		const deployedVersion = process.env.VITE_APP_VERSION ?? 'dev-local';
		result.response.headers.set(APP_VERSION_HEADER, deployedVersion);
	}
	return result;
});

export const startInstance = createStart(() => ({
	requestMiddleware: [appVersionHeaderMiddleware],
	serverFns: {
		fetch: appVersionAwareFetch,
	},
}));
